var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#4884E8",
    cx: 19,
    cy: 19,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.612 14.029c-.379-.423-1.097-.378-1.522.063l-6.85 6.951-3.288-3.48c-.535-.557-1-.707-1.512-.265-.512.441-.324 1.104.084 1.562l3.957 4.436c.208.232.483.35.76.35.262 0 .524-.106.73-.318l7.524-7.793c.425-.44.496-1.084.117-1.506z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.9ccbfd7f.svg";
export { ForwardRef as ReactComponent };